export default __webpack_public_path__ + "static/media/nativeUpdated.e3a2df66.jpg";